var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RewardNavbarLayout',{attrs:{"hasReward":_vm.hasReward},on:{"onRewardClick":_vm.onRewardClick}})}
var staticRenderFns = []

export { render, staticRenderFns }